import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-abee4e02")

_pushScopeId("data-v-abee4e02")
const _hoisted_1 = { class: "imgList" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.imgList, (item, idx) => {
      return (_openBlock(), _createBlock("img", {
        key: idx,
        src: item
      }, null, 8, ["src"]))
    }), 128))
  ]))
})